<template>
	<div>
		<b-breadcrumb class="flex-nowrap m-0" :items="breadcrumbs"/>
		<transition name="slide-left-only" appear>
			<div class="px-3 pt-3">
			<div class="row mb-3">
				<div
				v-for="module in availableModules"
				class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3"
				>
					<router-link
					:to="module.enabled ? module.url : '#'"
					class="page-menu-item d-flex align-items-start h-100 position-relative"
					:class="module.enabled ? '' : 'page-menu-item-disabled'"
					>
						<span style="top: 4px;right: 4px;" v-if="module.enabled && module.badge" class="badge badge-danger badge-lg position-absolute" v-b-tooltip.html="module.tooltip ? module.tooltip : ''">
							<span class="fas fa-exclamation-circle fa-fw"></span> {{ module.badge }}
						</span>
						<div class="mr-3 text-muted">
							<span
								:class="'page-menu-item-icon ' + (module.enabled ? 'fal' : 'fal') + ' fa-' + module.icon + ' fa-fw fa-2x'"
								style="--fa-primary-color: #3296d7; --fa-secondary-color: #009bff;"
							>
							</span>
						</div>
						<div class="d-flex flex-column text-truncate">
							<div class="line-height-1 mb-2 d-flex">
								<span class="text-truncate" v-html="module.title"></span>
							</div>
							<div class="text-muted line-height-1 small text-muted text-wrap" v-html="module.description">
							</div>
						</div>
					</router-link>
				</div>
			</div>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'home',
	data () {
		return {
			breadcrumbs: [
				{
					text: 'Главная',
					to: '/'
				},
				{
					text: 'Контрольно-надзорная деятельность',
					active: true
				}
			]
		}
	},
	components: {
	},
	computed: {
		profile () {
			return this.$store.getters.profile
		},
		availableModules () {
			var arr = []

			arr.push({
				title: 'КНД: Форма №1',
				description: 'Оперативная информация о деятельности территориальных управлений Росрыболовства по осуществлению федерального государственного надзора в области рыболовства, сохранения водных биологических ресурсов в среде их обитания во внутренних водоемах РФ',
				url: '/knd/knd_forms_01',
				icon: 'folders',
				enabled: true,
				badge: 0
			})

			return arr
		}
	},
	methods: {
	},
	mounted () {
	},
	watch: {
	}
}
</script>
